export default class ClientDashboard {
  clientId?: number | null;
  messages?: string[] | null;

  public constructor(params: ClientDashboard = {} as ClientDashboard) {
    let { clientId = null, messages = [] } = params;
    this.clientId = clientId;
    this.messages = messages;
  }
}
